var loadingNextPage = false;
$(document).on("click", "[data-action]", function(e) {
    if (loadingNextPage)
        return true;
    loadingNextPage = true;
    var action = this.dataset.action;

    if (action === "load-more" || action === "load-more-manual" || action === "load-replace") {
        e.preventDefault();
        this.setAttribute("disabled", "disabled");
        this.innerHTML = "Loading...";
        this.classList.remove("btn-arrow-down");
        this.classList.add("btn-is-loading");

        var target = this.dataset.target;
        var that = this;
        $.ajax(this.href, {
            success: function(data) {
                var href = that.href;
                $(that).remove();

                if (action === "load-more") {
                    $(target).append($(data).find(target).html());
                //     window.historyInitiated = true;
                //     history.pushState(null, null, href);

                } else if (action === "load-replace") {
                    $(target).html($(data).find(target).html());
                //     window.historyInitiated = true;
                //     history.pushState(null, null, href);
                }
                loadingNextPage = false;

            }
        });
    }
});

//Infinite Scroll
$(window).on("scroll", function() {
    //page height
    var scrollHeight = $(document).height();
    //scroll position
    var scrollPos = $(window).height() + $(window).scrollTop();
    // fire if the scroll position is 300 pixels above the bottom of the page
    if (((scrollHeight - 600) >= scrollPos) / scrollHeight == 0) {
        $('[data-action="load-more"]').click();
    }
});
$(document).on('change','[data-update-layout]',function(e) {
    if ($(this).is(':checked'))
    {
        $(this).closest('.select-layout').find('.active').removeClass('active');
        $(this).closest('.btn').addClass('active');
        $(this).closest('form').attr('action',window.location.pathname+'#prop-container');
        $(this).closest('form').submit();
    }
});

$(document).on('ready',function() {
    if ($('#prop-carousel').length) {
        $('[data-action="load-more-manual"]').css('display','none');
    }
});
$('#prop-carousel').on('cycle-next', function(event, optionHash) {
    // listen - are they less than 20 away from the end of the slideshow?
    var currSlide = optionHash.currSlide;
    var slideCount = optionHash.slideCount;
    if (currSlide >= slideCount - 20)
    {
        // do we have a "next page"?
        if ($('[data-action="load-more-manual"]').length) {
            var nextLink = $('[data-action="load-more-manual"]').attr('href');
            $('[data-action="load-more-manual"]').remove();

            // load the next page
            $.ajax(nextLink, {
                success: function(data) {
                    var $data = $(data);
                    // find the slides
                    $(data).find('.cycle-item').each(function() {
                        $('#prop-carousel').cycle('add',$(this)[0]);
                    });
                    $('#prop-carousel').after($(data).find('[data-action="load-more-manual"]'));
                    $('[data-action="load-more-manual"]').css('display','none');
                    window.historyInitiated = true;
                    history.pushState(null, null, href);
                }
            });
        }
    }
});